(() => {
  let pending = false;
  const root = () => window.Shopify?.routes?.root || '/';
  const propertiesKey = value => {
    const properties = Array.isArray(value) ? Object.fromEntries(value) : (value || {});
    return JSON.stringify(Object.entries(properties).sort(([a], [b]) => a.localeCompare(b)));
  };
  const matchesLine = (item, identity) =>
    String(item.variant_id) === identity.variant &&
    String(item.selling_plan_allocation?.selling_plan?.id || 0) === identity.plan &&
    propertiesKey(item.properties) === identity.properties;
  const update = async (input, quantity) => {
    const drawer = input.closest('[data-native-cart]');
    const sourceLine = input.closest('[data-line-key]');
    if (pending || !drawer || !sourceLine || !Number.isInteger(quantity) || quantity < 0) return;
    const key = sourceLine.dataset.lineKey;
    const identity = {
      variant: sourceLine.dataset.variantId,
      plan: sourceLine.dataset.sellingPlanId,
      properties: propertiesKey(JSON.parse(sourceLine.dataset.lineProperties || '{}'))
    };
    const focusStep = input.dataset.eoStep;
    const scroll = drawer.querySelector('.eo-cart__scroll')?.scrollTop || 0;
    const section = document.querySelector('[data-header-section]')?.dataset.headerSection;
    pending = true;
    drawer.setAttribute('aria-busy', 'true');
    drawer.querySelectorAll('button,input').forEach(el => el.disabled = true);
    const errorBox = drawer.querySelector('.eo-cart__error');
    if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
    const render = async cart => {
      if (!section) throw new Error(drawer.dataset.error);
      let html = cart.sections?.[section];
      if (!html) {
        const refresh = new URL(location.href);
        refresh.searchParams.set('section_id', section);
        const result = await fetch(refresh, {cache:'no-store'});
        if (!result.ok) throw new Error(drawer.dataset.error);
        html = await result.text();
      }
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.querySelector('[data-native-cart]');
      if (!next) throw new Error(drawer.dataset.error);
      drawer.innerHTML = next.innerHTML;
      const scroller = drawer.querySelector('.eo-cart__scroll');
      if (scroller) scroller.scrollTop = scroll;
      document.querySelectorAll('.cart-link__count').forEach(el => el.textContent = cart.item_count);
      const line = [...drawer.querySelectorAll('[data-line-key]')].find(el =>
        el.dataset.variantId === identity.variant &&
        el.dataset.sellingPlanId === identity.plan &&
        propertiesKey(JSON.parse(el.dataset.lineProperties || '{}')) === identity.properties);
      const target = focusStep ? line?.querySelector('[data-eo-step="' + focusStep + '"]') : line?.querySelector('[data-eo-quantity]');
      (target || drawer.querySelector('[data-dialog-close]'))?.focus({preventScroll:true});
    };
    try {
      const snapshotResponse = await fetch(root() + 'cart.js', {cache:'no-store', headers:{Accept:'application/json'}});
      if (!snapshotResponse.ok) throw new Error(drawer.dataset.error);
      const snapshot = await snapshotResponse.json();
      let index = snapshot.items.findIndex(item => item.key === key);
      if (index < 0) {
        const matches = snapshot.items.map((item, index) => ({item, index})).filter(({item}) => matchesLine(item, identity));
        if (matches.length !== 1) {
          await render(snapshot);
          return;
        }
        index = matches[0].index;
      }
      const nextQuantity = focusStep ? Math.max(0, snapshot.items[index].quantity + Number(focusStep)) : quantity;
      const response = await fetch(root() + 'cart/change.js', {
        method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({line:index + 1, quantity:nextQuantity, sections:[section], sections_url:location.pathname})
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || cart.message || drawer.dataset.error);
      await render(cart);
    } catch (error) {
      const box = drawer.querySelector('.eo-cart__error');
      if (box) { box.hidden = false; box.textContent = error.message || drawer.dataset.error; }
    } finally {
      pending = false;
      drawer.removeAttribute('aria-busy');
      drawer.querySelectorAll('button,input').forEach(el => el.disabled = false);
    }
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-eo-step],[data-eo-remove]');
    if (!button) return;
    event.preventDefault();
    const quantity = Number(button.closest('[data-line-key]').querySelector('[data-eo-quantity]').value);
    update(button, button.hasAttribute('data-eo-remove') ? 0 : Math.max(0, quantity + Number(button.dataset.eoStep)));
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-eo-quantity]')) update(event.target, Number(event.target.value));
  });
})();
